import { render, staticRenderFns } from "./ClassCascaderSelect.vue?vue&type=template&id=36fa7d78"
import script from "./ClassCascaderSelect.vue?vue&type=script&lang=js"
export * from "./ClassCascaderSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports